import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-pF3yVV3T.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--ar-AE" */'./ar-AE-ENGntAAL.js'),
  'de-DE': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--de-DE" */'./de-DE-AO3Mh8mx.js'),
  'en-AU': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--en-AU" */'./en-AU-1s2DNtRh.js'),
  'en-CA': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--en-CA" */'./en-CA-CAXD3_LE.js'),
  'en-GB': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--en-GB" */'./en-GB-1Jt-WZk7.js'),
  'en-IN': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--en-IN" */'./en-IN-DtbqH0r6.js'),
  'en-SG': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--en-SG" */'./en-SG-CJ2flR7O.js'),
  'es-CO': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--es-CO" */'./es-CO-BeQDmmLn.js'),
  'es-ES': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--es-ES" */'./es-ES-ycBeq1XR.js'),
  'es-MX': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--es-MX" */'./es-MX-EobU64Jw.js'),
  'fr-CA': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--fr-CA" */'./fr-CA-BBtcjwtv.js'),
  'fr-FR': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--fr-FR" */'./fr-FR-cfaSTsKl.js'),
  'hi-IN': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--hi-IN" */'./hi-IN-Da6GCsmi.js'),
  'it-IT': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--it-IT" */'./it-IT-6xObKIBp.js'),
  'ja-JP': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--ja-JP" */'./ja-JP-H2zpdZje.js'),
  'ko-KR': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--ko-KR" */'./ko-KR-RJSOhDD-.js'),
  'nl-NL': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--nl-NL" */'./nl-NL-xxW2m-FP.js'),
  'pl-PL': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--pl-PL" */'./pl-PL-ChabFbxn.js'),
  'pt-BR': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--pt-BR" */'./pt-BR-CdThl7Nb.js'),
  'sv-SE': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--sv-SE" */'./sv-SE-BOrY80XK.js'),
  'ta-IN': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--ta-IN" */'./ta-IN-BmePFPDu.js'),
  'th-TH': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--th-TH" */'./th-TH-Dmc2KEqG.js'),
  'tr-TR': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--tr-TR" */'./tr-TR-DjnFUYeV.js'),
  'vi-VN': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--vi-VN" */'./vi-VN-C7EkFyyd.js'),
  'zh-CN': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--zh-CN" */'./zh-CN-920VOwdc.js'),
  'zh-TW': () => import(/* webpackChunkName: "storm-ui--FileDownloadButton--zh-TW" */'./zh-TW-B5JNx13k.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-CdrbKyuw.js.map
